module.exports = __webpack_public_path__ + "media/images/home/ouvert_365jours-554734adbfca987d66fed39ed0184f72.png";